import ServiceApi from "../ServiceApi";

class TermsServiceApi extends ServiceApi {
  constructor() {
    super("termsService", "terms");
  }

  info() {
    return this.request("info", { extended: true });
  }

  accept() {
    return this.request("accept");
  }
}

const service = new TermsServiceApi();
export default service;
